class SimpleProduct {
  static basePrice(currency, conversions) {
    const conversionTable = conversions[0];

    return conversionTable.data[currency.toUpperCase()];
  }

  static calculatedPrice(conversions) {
    const currencies = ['usd', 'gbp', 'aud', 'cad', 'eur'];
    let prices = {};

    for (let currency of currencies) {
      let price = SimpleProduct.basePrice(currency, conversions);

      prices[currency] = price;
    }

    return prices;
  }

  static compiledId(reference) {
    return reference;
  }

  static description() {
    return '';
  }

  static entriesForPriceTable(data, server_root) {
    return {
      id: SimpleProduct.compiledId(data.Reference),
      price: (
        (data.Discount_Price_Profile && data.Discount_Price_Profile.length > 0) ?
          SimpleProduct.calculatedPrice(data.Discount_Price_Profile[0].data.Conversions)
          :
          SimpleProduct.calculatedPrice(data.Price_Profile[0].data.Conversions)
      ),
      url: `${server_root}/data/products/${data.Reference}.json`,
    };
  }
};

module.exports = SimpleProduct;
